import { render, staticRenderFns } from "./TestDetailDialog.vue?vue&type=template&id=526b0183&scoped=true"
import script from "./TestDetailDialog.vue?vue&type=script&lang=js"
export * from "./TestDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TestDetailDialog.vue?vue&type=style&index=0&id=526b0183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b0183",
  null
  
)

export default component.exports